import { render, staticRenderFns } from "./SLAQrisly.vue?vue&type=template&id=5f2c212c&"
import script from "./SLAQrisly.vue?vue&type=script&lang=js&"
export * from "./SLAQrisly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports